import { signedFetch } from '../../services/api';

/**
 * Ask whether to auto-open Linus's help card on the Success Closer tab, recording the
 * viewing if so. The backend keeps this in Firestore per CEA — the native WebView
 * drops localStorage — and answers true at most once every 48h.
 *
 * Any failure reads as "don't show": the Help pull tab still opens it on demand.
 */
export async function claimSuccessCloserHelp(): Promise<boolean> {
  try {
    // redirectOnAuthError: false — a help card must never bounce the agent to /unauthorized.
    const response = await signedFetch('/api/super-picker/splash/success-closer-help/claim', { method: 'POST' }, true, false);
    if (!response.ok) return false;
    const body = await response.json();
    return body?.show === true;
  } catch (error) {
    console.error('Failed to claim Success Closer help view:', error);
    return false;
  }
}
